<mat-toolbar color="primary">
  <button mat-icon-button aria-label="hamburger" class="menu-button mobile-only" (click)="menuOpened = !menuOpened">
    <mat-icon>{{ menuOpened ? 'menu_open' : 'menu' }}</mat-icon>
  </button>
  <h1 class="header-title">Predict</h1>
  <span class="spacer"></span>
  <div class="header-container web-only">
    <mat-icon (click)="langSelect.open()" class="header-icon lang-icon">language</mat-icon>
    <mat-label class="lang-label" (click)="langSelect.open()">{{'header.language-label' | translate}}</mat-label>
    <mat-select #langSelect id="lang-select" panelWidth="fit-content" [(value)]="language.selectedLanguage" class="lang-select">
      <mat-option *ngFor="let lang of language.languages" [value]="lang">{{ lang }}</mat-option>
    </mat-select>
  </div>
  <div class="header-container username web-only">
    <mat-icon class="header-icon">person</mat-icon>
    <span #name class="name-value" [matTooltip]="userName"
      [matTooltipDisabled]="name.offsetWidth === name.scrollWidth">{{ userName }}</span>
  </div>
  <button mat-icon-button aria-label="Logout" class="logout-button web-only"
    [matTooltip]="'header.change-password-button' | translate" routerLink="/change-password">
    <mat-icon>lock_reset</mat-icon>
  </button>
  <button mat-icon-button aria-label="Logout" class="logout-button web-only"
    [matTooltip]="'header.logout-button' | translate" routerLink="/logout">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>
